import Axios from "axios";
import {
  CLEAR_ERRORS,
  GET_DOCUMENT,
  GET_ERRORS,
  GET_DOCUMENTS,
  LOADING_DOCUMENTS,
} from "./types";
import { logoutUser } from "./authAction";
const token = document.querySelector('meta[name="csrf-token"]').content;
Axios.defaults.headers.common["X-CSRF-Token"] = token;

export const postDocument = (variables) => (dispatch) => {
  Axios.post("/api/v1/contracts", variables)
    .then((res) => {
      //   dispatch({
      //     type: POST_COMMENTS,
      //     payload: res.data
      //   });
      //   dispatch(clearErrors());
      //   success("post");
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
      //   error();
    });
};

export const getDocument = (page, pageCount, filter) => (dispatch) => {
  dispatch(setDocumentLoading());
  console.time();
  Axios.get(`/api/v1/contracts.json?page=${page}&per_page=${pageCount}${filter}`)
    .then((res) => {
      console.timeEnd()
      if(res.data == undefined || Object.keys(res.data).length === 0) {
        return dispatch(logoutUser())
      } 
      dispatch({
        type: GET_DOCUMENTS,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const getDocumentShow = (id) => (dispatch) => {
  Axios.get(`/api/v1/contracts/${id}`)
    .then((res) => {
      dispatch({
        type: GET_DOCUMENT,
        payload: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
    });
};

export const deleteDocument = (_id) => (dispatch) => {
  if (confirm("Are you sure want to delete? ")) {
    Axios.delete(`/api/v1/contracts/${_id}`)
      .then((res) => {
        // success();
      })
      .catch((err) => {
        dispatch({
          type: GET_ERRORS,
          payload: err.response.data,
        });
        // error();
      });
  }
};

export const updateDocument = (_id, body) => (dispatch) => {
  Axios.put(`/api/v1/contracts/${_id}`, body)
    .then((res) => {
      dispatch(clearErrors());
      //   success("update");
    })
    .catch((err) => {
      dispatch({
        type: GET_ERRORS,
        payload: err.response.data,
      });
      //   error();
    });
};

export const setDocumentLoading = () => {
  return {
    type: LOADING_DOCUMENTS,
  };
};

export const clearErrors = () => {
  //   return {
  //     type: CLEAR_ERRORS,
  //   };
};
